var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4167 1C20.948 1 23 3.05203 23 5.58333V18.4167C23 20.948 20.948 23 18.4167 23H5.58333C3.05203 23 1 20.948 1 18.4167V5.58333C1 3.05203 3.05203 1 5.58333 1H18.4167ZM18.4168 2.83331H5.5835C4.11896 2.83331 2.92181 3.97816 2.83816 5.42173L2.8335 5.58331V18.4166C2.8335 19.8812 3.97834 21.0783 5.42191 21.162L5.5835 21.1666H18.4168C19.8814 21.1666 21.0785 20.0218 21.1622 18.5782L21.1668 18.4166V5.58331C21.1668 4.11877 20.022 2.92162 18.5784 2.83798L18.4168 2.83331ZM14 4.66669C12.8954 4.66669 12 5.56212 12 6.66669V17.3334C12 18.4379 12.8954 19.3334 14 19.3334H17.3333C18.4379 19.3334 19.3333 18.4379 19.3333 17.3334V6.66669C19.3333 5.56212 18.4379 4.66669 17.3333 4.66669H14Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebar);
export default __webpack_public_path__ + "static/media/sidebar.513fbbfc3d891478d9dcb5f77c2f7010.svg";
export { ForwardRef as ReactComponent };